/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PolicyTypes {
  PERCENT = 'percent',
  FIXED = 'fixed',
}
